var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71454 23.5707C9.80141 23.6891 9.91486 23.7854 10.0458 23.8519C10.1767 23.9185 10.3213 23.9533 10.4682 23.9537H21.8762C22.0361 23.9532 22.1933 23.9118 22.3328 23.8335C22.4722 23.7553 22.5895 23.6427 22.6733 23.5065L24.3648 20.728C24.4533 20.5819 24.5 20.4143 24.5 20.2435C24.5 20.0727 24.4533 19.9052 24.3648 19.7591L18.4538 10.0488C18.3697 9.91141 18.2516 9.79807 18.1108 9.71973C17.9701 9.64138 17.8115 9.60069 17.6505 9.60158H14.3378C14.1781 9.60211 14.0212 9.64348 13.8821 9.72176C13.7429 9.80003 13.6261 9.91261 13.5427 10.0488L7.63584 19.7384C7.54007 19.8959 7.49309 20.0783 7.50082 20.2625C7.50856 20.4468 7.57067 20.6246 7.67932 20.7736L9.71454 23.5707ZM21.8182 22.9185H10.6504L11.963 20.7611H23.1433L21.8182 22.9185ZM19.3938 19.7259H12.5945L15.9941 14.1399L19.3938 19.7259ZM23.1329 19.7259H20.607L15.0749 10.6368H17.6008L23.1329 19.7259ZM14.1307 11.0674L15.3937 13.1379L9.93194 22.109L8.55718 20.2187L14.1307 11.0674Z",
    fill: "#F48B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/google_drive.e6d2d7b5650dabeb812676732ca595dc.svg";
export { ForwardRef as ReactComponent };